import { render, staticRenderFns } from "./mers.vue?vue&type=template&id=67ed7051&scoped=true"
import script from "./mers.vue?vue&type=script&lang=js"
export * from "./mers.vue?vue&type=script&lang=js"
import style0 from "./mers.vue?vue&type=style&index=0&id=67ed7051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed7051",
  null
  
)

export default component.exports